// const Imageurldata = "http://13.233.110.14:4000/api";
const Imageurldata = `${process.env.REACT_APP_AZURE_OBJECT_URL}`;
export default Imageurldata;
